import { ChangeEvent, useEffect } from 'react';
import { useForm } from 'react-hook-form';

import { MyInfoFormData } from 'api/userApi';
import ErrorMessage from 'components/widget/ErrorMessage';
import { User } from 'model/User';
import { formatPhoneNumber } from 'util/stringUtil';
import { mypageUpdateSchema } from './resolvers/MypageResolvers';

type UserInfoFormProps = {
  item: User | undefined;
  onPasswordModalClick: () => void;
  onSubmit: (formData: MyInfoFormData) => void;
};

function UserInfoForm({ item, onPasswordModalClick, onSubmit }: UserInfoFormProps) {
  const {
    register,
    setValue,
    reset,
    handleSubmit,
    formState: { errors },
  } = useForm({ resolver: mypageUpdateSchema });

  useEffect(() => {
    if (!item) {
      return;
    }

    reset({ ...item, phone: formatPhoneNumber(item?.phone) });
  }, [item, reset]);

  const handleChangePhone = (event: ChangeEvent<HTMLInputElement>) => {
    setValue('phone', formatPhoneNumber(event.target.value), {
      shouldValidate: true,
    });
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <h2>{'내정보'}</h2>
      <div className={'table-wrap mt-40'}>
        <table className={'tbl-type-05 input-design input-small '}>
          <caption>{'관리자정보'}</caption>
          <colgroup>
            <col width={'20%'} />
            <col />
          </colgroup>
          <tbody>
            <tr>
              <th>
                <p>{'아이디'}</p>
              </th>
              <td>
                <input
                  type={'text'}
                  className={'input-box-type-01'}
                  {...register('account')}
                  disabled
                  maxLength={50}
                />
              </td>
            </tr>
            <tr>
              <th>
                <p>{'이름'}</p>
              </th>
              <td>
                <input
                  type={'text'}
                  className={'input-box-type-01'}
                  {...register('name')}
                  maxLength={50}
                />
              </td>
            </tr>
            <tr>
              <th>
                <p>{'비밀번호'}</p>
              </th>
              <td>
                <div className={'input-box-group'}>
                  <button
                    type={'button'}
                    className={'btn-type-04 w15rem'}
                    onClick={onPasswordModalClick}
                  >
                    {'비밀번호변경'}
                  </button>
                </div>
              </td>
            </tr>
            <tr>
              <th>
                <p>{'휴대폰번호'}</p>
              </th>
              <td>
                <input
                  type={'text'}
                  className={'input-box-type-01'}
                  {...register('phone')}
                  onChange={handleChangePhone}
                  maxLength={50}
                />
              </td>
            </tr>
            <tr>
              <th>
                <p>{'이메일'}</p>
              </th>
              <td>
                <input
                  type={'text'}
                  className={'input-box-type-01'}
                  {...register('email')}
                  maxLength={50}
                />
              </td>
            </tr>
          </tbody>
        </table>
        <ErrorMessage errors={errors} />
      </div>
      <div className={'btn-group no-bg input-large mt-40'}>
        <button type={'submit'} className={'btn-type-01'}>
          {'수정'}
        </button>
      </div>
    </form>
  );
}

export default UserInfoForm;
